import React from 'react';
import { IDashboardApplicationItem } from '@apply/api/src/api/ApplyApi';
import { NewApplicationPanel } from './NewApplicationPanel';
import { ApplyDraftPanel } from './ApplyDraftPanel';
import { ApplyPendingApprovalPanel } from './ApplyPendingApprovalPanel';
import { LoansApprovedToClosePanel } from './LoansApprovedToClosePanel';
import { LoanDrawPanel } from './LoanDrawPanel/LoanDrawPanel';
import { IDashboardDrawBudget } from '@apply/api/src/api/DrawApi';

interface IDashboardParameters {
    inProgressApplications: IDashboardApplicationItem[];
    applicationsPendingApproval: IDashboardApplicationItem[];
    applicationsReadyToClose: IDashboardApplicationItem[];
    deleteApplication: (applicationId: number) => void;
    dashboardDrawBudgets: IDashboardDrawBudget[];
    loading: boolean;
}

export const Dashboard: React.FC<IDashboardParameters> = ({
    inProgressApplications,
    applicationsPendingApproval,
    applicationsReadyToClose,
    deleteApplication,
    dashboardDrawBudgets,
    loading,
}) => {
    return (
        <div className='content'>
            <div className='contentSection'>
                <NewApplicationPanel />
                <ApplyDraftPanel
                    applications={inProgressApplications}
                    deleteApplication={deleteApplication}
                />
                <ApplyPendingApprovalPanel applications={applicationsPendingApproval} />
            </div>
            <div className='contentSection'>
                <LoansApprovedToClosePanel applications={applicationsReadyToClose} />
                <LoanDrawPanel dashboardDrawBudgets={dashboardDrawBudgets} loading={loading} />
            </div>
        </div>
    );
};
